(function () {
  if (window.__cze) return; window.__cze = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var edit = root.classList.contains('shopify-design-mode');
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function reveals() {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    $$('.cz-reveal, .cz-split').forEach(function (el) { io.observe(el); });
  }

  /* ---------- steps carousel: native swipe + arrows + mouse drag ---------- */
  function steps() {
    $$('.czp-steps').forEach(function (s) {
      var tr = s.querySelector('.czp-steps__track'); if (!tr) return;
      var cards = $$('.czp-step', tr), n = cards.length;
      var prev = s.querySelector('[data-dir="-1"]'), next = s.querySelector('[data-dir="1"]');
      var cnt = s.querySelector('.czp-steps__count'), bar = s.querySelector('.czp-steps__bar i');
      var step = function () { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : tr.clientWidth; };
      var update = function () {
        var max = tr.scrollWidth - tr.clientWidth;
        var p = max > 0 ? tr.scrollLeft / max : 1;
        var idx = Math.min(n, Math.round(tr.scrollLeft / step()) + 1);
        if (cnt) cnt.textContent = pad(idx) + ' / ' + pad(n);
        if (bar) bar.style.transform = 'scaleX(' + Math.max(1 / n, p) + ')';
        if (prev) prev.disabled = tr.scrollLeft < 4;
        if (next) next.disabled = tr.scrollLeft > max - 4;
      };
      var go = function (dir) { tr.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' }); };
      [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { go(+b.getAttribute('data-dir')); }); });
      tr.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      // horizontal trackpad swipes belong to the carousel, not to the page smooth-scroll
      tr.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.stopPropagation(); }, { passive: true });
      tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } });
      // mouse drag (touch & trackpad use native scrolling)
      var down = false, sx = 0, sl = 0, moved = 0;
      tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = 0; sx = e.clientX; sl = tr.scrollLeft; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
        if (moved > 4) { tr.classList.add('is-drag'); tr.scrollLeft = sl - dx; }
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (tr.classList.contains('is-drag')) {
          tr.classList.remove('is-drag');
          var t = Math.round(tr.scrollLeft / step()) * step();
          tr.scrollTo({ left: t, behavior: 'smooth' });
        }
      });
      update(); window.addEventListener('resize', update);
    });
  }

  /* ---------- pack selector ---------- */
  function pack() {
    $$('[data-pack]').forEach(function (fs) {
      var sec = fs.closest('.czp-pack'), btn = sec && sec.querySelector('[data-pack-buy]'), vid = fs.getAttribute('data-variant');
      $$('input', fs).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!btn || !r.checked) return;
          btn.href = '/cart/' + vid + ':' + r.value;
          btn.textContent = r.getAttribute('data-label');
        });
      });
    });
  }

  /* ---------- story "Cómo se usa": chapter in the middle of the screen drives image ---------- */
  function story() {
    $$('.czst').forEach(function (s) {
      var chs = $$('.czst__ch', s), imgs = $$('.czst__img', s), dots = $$('.czst__dot', s), n = chs.length;
      if (!n || !window.IntersectionObserver) return;
      var set = function (i) {
        if (i < 0) return;
        chs.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
        imgs.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
        dots.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
        s.style.setProperty('--czst-p', n > 1 ? i / (n - 1) : 1);
      };
      set(0);
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) set(chs.indexOf(e.target)); }); }, { rootMargin: '-45% 0px -45% 0px' });
      chs.forEach(function (c) { io.observe(c); });
    });
  }

  function split(el) {
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var f = d.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { f.appendChild(d.createTextNode(w)); return; }
            var s = d.createElement('span'); s.className = 'czx-lw'; s.textContent = w; f.appendChild(s);
          });
          c.parentNode.replaceChild(f, c);
        } else if (c.nodeType === 1 && !c.classList.contains('czx-pill')) walk(c);
      });
    })(el);
    return el.querySelectorAll('.czx-lw');
  }

  function motion() {
    var g = window.gsap, ST = window.ScrollTrigger;
    g.registerPlugin(ST);
    root.classList.add('e-anim');

    // Horizon scrolls inside .page-wrapper (html/body are locked to 100dvh), not the window.
    var pw = d.querySelector('.page-wrapper');
    var sc = (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) ? pw : window;
    if (sc !== window) { ST.defaults({ scroller: sc }); sc.style.scrollBehavior = 'auto'; }
    window.__czScroller = sc;
    var toY = function (y) { if (sc === window) window.scrollTo({ top: y, behavior: 'smooth' }); else sc.scrollTo({ top: y, behavior: 'smooth' }); };
    window.__czTo = toY;
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a) return;
      var id = a.getAttribute('href').slice(1); var t = id && d.getElementById(id); if (!t) return;
      e.preventDefault();
      var top = sc === window ? t.getBoundingClientRect().top + window.scrollY : t.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop;
      toY(Math.max(0, top - 20));
    });

    // HERO: telón de tinta con monograma, marco dorado que se dibuja, palabras que emergen
    $$('.czp-hero').forEach(function (h) {
      var w1 = h.querySelector('.czp-w--1'), w2 = h.querySelector('.czp-w--2');
      var pr = h.querySelector('.czp-hero__prod'), sh = h.querySelector('.czp-hero__shadow');
      var bottom = $$('.czp-hero__txt, .czp-hero__ctas, .czp-hero__down', h);
      var veil = d.createElement('div'); veil.className = 'czp-veil'; veil.setAttribute('aria-hidden', 'true');
      veil.innerHTML = '<i class="czp-veil__mark"></i><b class="czp-veil__line"></b>';
      h.appendChild(veil);
      var frame = d.createElement('span'); frame.className = 'czp-frame'; frame.setAttribute('aria-hidden', 'true'); h.appendChild(frame);
      var tl = g.timeline({ defaults: { ease: 'expo.out' } });
      tl.from(veil.firstChild, { autoAlpha: 0, scale: 0.8, duration: 0.7, ease: 'power3.out' }, 0)
        .from(veil.lastChild, { scaleX: 0, duration: 0.7, ease: 'power3.inOut' }, 0.15)
        .to(veil.firstChild, { autoAlpha: 0, y: -30, duration: 0.5, ease: 'power2.in' }, 0.85)
        .to(veil, { clipPath: 'inset(0% 0% 100% 0%)', duration: 1.1, ease: 'expo.inOut' }, 1.0)
        .from([w1, w2], { yPercent: 70, clipPath: 'inset(0% 0% 100% 0%)', duration: 1.6, stagger: 0.12 }, 1.45)
        .from(pr, { yPercent: 16, scale: 0.84, autoAlpha: 0, duration: 2, ease: 'expo.out' }, 1.35)
        .from(sh, { scale: 0.3, autoAlpha: 0, duration: 1.6 }, 1.6)
        .from(frame, { clipPath: 'inset(50% 50% 50% 50%)', duration: 1.6, ease: 'expo.inOut' }, 1.5)
        .from(bottom, { y: 30, autoAlpha: 0, duration: 1.1, stagger: 0.08 }, 1.9)
        .add(function () { veil.remove(); });
      g.to(pr, { y: -12, rotate: 1.5, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 3.4 });
      var st = g.timeline({ scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: true } });
      st.to(w1, { xPercent: -32, ease: 'none' }, 0)
        .to(w2, { xPercent: 32, ease: 'none' }, 0)
        .to(pr.querySelector('img'), { rotate: 14, scale: 1.18, yPercent: 20, ease: 'none' }, 0)
        .to(frame, { scale: 1.06, autoAlpha: 0, ease: 'none' }, 0)
        .to(sh, { autoAlpha: 0, ease: 'none' }, 0);
    });

    // títulos: emergen tras una máscara, línea a línea
    $$('.czp-steps__head .czp-h, .czp-pack__h').forEach(function (t) {
      g.from(t, { yPercent: 30, clipPath: 'inset(0% 0% 100% 0%)', duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: t, start: 'top 96%' } });
    });

    // secciones oscuras: se abren como un telón al entrar
    $$('.czp-pack, .czx-black, .czp-out').forEach(function (sec) {
      g.fromTo(sec, { clipPath: 'inset(7% 5% 0% 5%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'top 25%', scrub: true } });
    });

    // manifesto
    $$('.czx-man').forEach(function (m) {
      var txt = m.querySelector('.czx-light'), ws = txt ? split(txt) : [], n = ws.length, last = -1;
      ST.create({ trigger: txt || m, start: 'top 88%', end: 'bottom 55%', scrub: true, onUpdate: function (s) {
        var k = Math.round(s.progress * n); if (k === last) return; last = k;
        for (var i = 0; i < n; i++) ws[i].classList.toggle('on', i < k);
      } });
    });

    // steps: cards rise in one after another (fast start so nothing ever looks empty)
    $$('.czp-steps').forEach(function (s) {
      g.from($$('.czp-steps__head > *', s), { y: 30, autoAlpha: 0, duration: 0.9, stagger: 0.08, ease: 'power3.out', scrollTrigger: { trigger: s, start: 'top 95%' } });
      var tl = g.timeline({ scrollTrigger: { trigger: s.querySelector('.czp-steps__track') || s, start: 'top 98%' }, defaults: { ease: 'expo.out' } });
      tl.from($$('.czp-step', s), { y: 70, autoAlpha: 0, duration: 1, stagger: 0.07 }, 0);
      var bar = s.querySelector('.czp-steps__bar'); if (bar) tl.from(bar, { scaleX: 0, transformOrigin: '0 50%', duration: 1.2, ease: 'expo.inOut' }, 0.2);
    });

    // pack: two dryers slide in from opposite sides, copy rises
    $$('.czp-pack').forEach(function (p) {
      var a = p.querySelector('.czp-pack__p--a'), b = p.querySelector('.czp-pack__p--b');
      var tl = g.timeline({ scrollTrigger: { trigger: p, start: 'top 82%' }, defaults: { ease: 'expo.out', duration: 1.2 } });
      if (a) tl.from(a, { xPercent: -45, rotate: -10, autoAlpha: 0, duration: 1.8 }, 0);
      if (b) tl.from(b, { xPercent: 45, rotate: 30, autoAlpha: 0, duration: 1.8 }, 0.12);
      tl.from($$('.czp-pack__lab', p), { y: 20, autoAlpha: 0, duration: 1, stagger: 0.12 }, 0.6)
        .from($$('.czp-tag, .czp-pack__lead, .czp-opt, .czp-pack__fine', p), { y: 40, autoAlpha: 0, duration: 1, stagger: 0.08 }, 0.25)
        .from($$('.czp-pack__buy', p), { autoAlpha: 0, duration: 0.8 }, 0.5);
      if (a) g.to(a, { yPercent: -8, ease: 'none', scrollTrigger: { trigger: p, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (b) g.to(b, { yPercent: 10, rotate: 22, ease: 'none', scrollTrigger: { trigger: p, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    // black statement
    $$('.czx-black').forEach(function (bk) {
      $$('.czx-pill', bk).forEach(function (pl) {
        g.from(pl, { width: 0, marginLeft: 0, marginRight: 0, duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: pl, start: 'top 85%' } });
      });
    });

    // outros
    $$('.czp-out, .czx-out').forEach(function (o) {
      g.from($$('.czp-tag, .czp-out .czp-h, .czp-out__row, .czp-out__top, .czx-big, .czx-out__row, .czx-out__top', o), { y: 50, autoAlpha: 0, stagger: 0.08, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: o, start: 'top 85%' } });
    });

    window.addEventListener('load', function () { ST.refresh(); });
    var rt; if (window.ResizeObserver) new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(function () { ST.refresh(); }, 150); }).observe(d.getElementById('MainContent') || d.body);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { ST.refresh(); });
  }

  function init() {
    reveals(); steps(); pack(); story();
    $$('.czx-out__top, [data-top]').forEach(function (a) {
      a.onclick = null;
      a.addEventListener('click', function (e) { e.preventDefault(); var s = window.__czScroller || d.querySelector('.page-wrapper') || window; s.scrollTo({ top: 0, behavior: 'smooth' }); });
    });
    if (!reduce && !edit && window.gsap && window.ScrollTrigger) {
      try { motion(); } catch (e) { root.classList.remove('e-anim'); $$('.czp-veil').forEach(function (v) { v.remove(); }); if (window.console) console.warn('[calzadry]', e); }
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
